import { css } from '@emotion/react';
import { IonCol, IonIcon, IonImg, IonRouterLink, IonRow, IonText } from '@ionic/react';
import { arrowUpRightBoxOutline } from 'ionicons/icons';
import React from 'react';
import ClarityDeviceImg from '../../assets/img/clarity_device.png';
import RefsiteDeviceImg from '../../assets/img/refsite_device.png';
import { useSettings } from '../../contexts/SettingsContext';
import * as commonCss from '../../styles/common';
import { MetricIndex, SourceType } from '../../types';
import { joinWithCommasAnd } from '../../shared/aqi';
import sortBy from 'lodash/sortBy';

export const MonitoringDevice: React.FC = () => {
  const { marker, network } = useSettings();

  const pollutantsMeasuredText = React.useMemo(() => {
    if (!network || !marker) {
      return null;
    }
    const measuredPollutantsDisplayNames = Object.keys(marker.metrics)
      .map((m) =>
        network.pollutantConfigs.find((pc) =>
          pc.metricInfos.filter((mi) => mi.indexType === MetricIndex.Aqi).find((mi) => mi.key === m)
        )
      )
      .filter(Boolean)
      .map((pi) => pi!.displayName);
    return measuredPollutantsDisplayNames.length > 0 ? joinWithCommasAnd(sortBy(measuredPollutantsDisplayNames)) : null;
  }, [network, marker]);

  if (!marker || !pollutantsMeasuredText) {
    return null;
  }

  const { sourceType } = marker;

  let imageSrc = '';
  let description = '';
  let link = null;

  switch (sourceType) {
    case SourceType.CLARITY_NODE:
      imageSrc = ClarityDeviceImg;
      description = 'Clarity Node-S';
      link = {
        text: 'learn more',
        url: 'https://www.clarity.io/products/clarity-node-s',
      };
      break;
    case SourceType.REFERENCE_SITE:
      imageSrc = RefsiteDeviceImg;
      description = 'Reference Monitor';
      break;
    default:
      break;
  }

  const monitoringDeviceCss = {
    self: [css({ gap: '.5rem', alignItems: 'center', justifyContent: 'center' })],
    img: [css({ height: 64 })],
    measuringText: [commonCss.smallText],
  };

  return (
    <IonRow css={monitoringDeviceCss.self}>
      <IonCol size="3">
        <IonImg src={imageSrc} alt="Device Image" css={monitoringDeviceCss.img} />
      </IonCol>
      <IonCol size="auto">
        <IonRow>
          <IonCol>
            <IonText>{description}</IonText>
            {link && (
              <>
                &nbsp;&nbsp;&ndash;&nbsp;&nbsp;
                <IonRouterLink href={link.url} color="primary" target="_blank">
                  <IonText>{link.text}</IonText>
                  <IonIcon size="small" color="primary" slot="end" icon={arrowUpRightBoxOutline} />
                </IonRouterLink>
              </>
            )}
          </IonCol>
        </IonRow>
        {pollutantsMeasuredText && (
          <IonRow css={commonCss.centered}>
            <IonCol>
              <IonText css={monitoringDeviceCss.measuringText}>Measuring: {pollutantsMeasuredText}</IonText>
            </IonCol>
          </IonRow>
        )}
      </IonCol>
    </IonRow>
  );
};
